import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../services/global.service';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  @Input() progress: string;
  @Input() detailsStyle: boolean = false;

  total: string = '';
  progressTotal: string = '';
  progressStyle: number;
  progressLabel: string = '';

  isNull() {
    if (this.progress == undefined || this.progress == '')
      this.progressStyle = 0;
    else 
      this.calculateTotal();
  }

  calculateTotal() {
    let arrayProgress = this.progress.split("/");
    let middle = this._gS.getLenguage() == 'eng' ? ' OF ' : ' DE ';
    this.total = arrayProgress[0].toString().replace(" ","");
    if (arrayProgress[1] != null || arrayProgress[1] != undefined) 
      this.progressTotal = arrayProgress[1].toString().replace(" ","");
    if (this.progressTotal == '0') 
      this.progressStyle = 0
    else {
      this.progressStyle = ((parseInt(this.total) * 100) / parseInt(this.progressTotal));
      this.progressLabel = this.total.toString() + middle + this.progressTotal.toString();
    } 
  }

  constructor(private _gS: GlobalService) { }

  ngOnInit(): void {
    this.isNull();
  }
}
